import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, ErrorHandler, NgModule } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClientModule, HttpClientJsonpModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { NavMenuComponent, NavMenuModule } from './shared/nav-menu/nav-menu.component';
import { LoginComponent } from './home/login.component';
import { AuthGuard } from '../services/auth-guard.service';
import { AccountService } from '../services/account.service';
import { AppRoutesModule } from './app.routes';
import { AppService } from '../services/app.service';
import { DynamicFormModule } from './shared/controls/dynamic/dynamic-form.component';
import { LookupService } from '../services/lookup.service';
import { RightNavComponent } from './shared/right-nav/right-nav.component';
import { LeftNavComponent } from './shared/left-nav/left-nav.component';
import { RequestResetPasswordComponent } from './home/request-reset-password.component';
import { ResetPasswordComponent } from './home/reset-password.component';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { DynamicValueModule } from './shared/controls/dynamic/dynamic-value.component';
import { DynamicControlErrorModule } from './shared/controls/dynamic/dynamic-control-error.component';
import { PasswordStrengthIndicatorComponent } from './shared/controls/password-strength-indicator.component';
import { DialogModule } from 'primeng/dialog';
import { TooltipModule } from 'primeng/tooltip';
import { MenuModule } from 'primeng/menu';
import { TableModule } from 'primeng/table';
import { LoadingModule } from './shared/controls/loading.component';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { InputMaskModule } from 'primeng/inputmask';
import { SortIconCustomModule } from './shared/controls/dynamic/sort-icon-custom.component';
import { LastUpdatedModule } from './shared/controls/last-updated.component';
import { UsersModule } from './users/users.module';
import { LocationsModule } from './locations/locations.module';
import { InvoicesModule } from './invoices/invoices.module';
import { SearchModule } from './search/search.module';
import { NotesDetailModule } from './shared/controls/notes-detail.component';
import { VehiclesDetailModule } from './shared/controls/vehicles-detail.component';
import { SearchFilterModule } from './shared/controls/dynamic/search-filter.component';
import { DetailModalModule } from './shared/detail-modal.component';
import { QuotesModule } from './quotes/quotes.module';
import { ColorPickerModule } from 'primeng/colorpicker';
import { OrdersModule } from './orders/orders.module';
import { AdminGuard } from '../services/admin-guard.service';
import { PermissionGuard } from '../services/permission-guard.service';
import { MessageService } from 'primeng/api';
import { NavigationService } from '../services/navigation.service';
import { FormHelperService } from '../services/form-helper.service';
import { AuthInterceptor } from '../services/auth.interceptor';
import { SanitizationInterceptor } from '../services/sanitization.interceptor';
import * as Sentry from "@sentry/angular";
import { LoaderComponent } from './loader.component';
import { OtpVerificationComponent } from './home/otp-verification.component';
import { SmsVerificationInfoComponent } from './home/sms-verification-info.component';
import { ApplicationInsightsService } from '../services/application-insights.service';
import { ApplicationInsightsInterceptor } from '../services/application-insights.interceptor';

@NgModule({
  declarations: [
    AppComponent,
    LeftNavComponent,
    RightNavComponent,
    LoginComponent,
    OtpVerificationComponent,
    SmsVerificationInfoComponent,
    RequestResetPasswordComponent,
    ResetPasswordComponent,
    LoaderComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    HttpClientModule,
    HttpClientJsonpModule,
    ToastModule,
    AppRoutesModule,
    DynamicFormModule,
    DynamicValueModule,
    DynamicControlErrorModule,
    PasswordStrengthIndicatorComponent,
    DialogModule,
    TooltipModule,
    MenuModule,
    TableModule,
    LoadingModule,
    ButtonModule,
    InputTextModule,
    InputMaskModule,
    SortIconCustomModule,
    LastUpdatedModule,
    UsersModule,
    LocationsModule,
    InvoicesModule,
    SearchModule,
    NotesDetailModule,
    VehiclesDetailModule,
    SearchFilterModule,
    DetailModalModule,
    QuotesModule,
    ColorPickerModule,
    OrdersModule,
    NavMenuModule,
  ],
  providers: [
    AuthGuard,
    AdminGuard,
    PermissionGuard,
    AccountService,
    MessageService,
    AppService,
    LookupService,
    NavigationService,
    FormHelperService,
    DatePipe,
    ApplicationInsightsService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: SanitizationInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ApplicationInsightsInterceptor, multi: true },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => { /**/},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
